import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  gap: 1.4rem;
`;

const ButtonWrapper = styled.div`
  position: relative;
`;

const Container = styled.div`
  position: absolute;
  top: 5rem;
  left: 0;

  padding: 1.2rem 2rem;

  background-color: ${pickColor('black')};
  border-radius: ${({ theme }) => theme.borderRadius.base};

  z-index: 99;
`;

export { Wrapper, ButtonWrapper, Container };
